import { createApp } from 'vue'
import './assets/css/tailwind.css'
import App from './App.vue'
import router from './router'
import pinia from './stores'



const app = createApp(App)
app.use(router)
app.use(pinia) // Utilisation de Pinia pour la gestion d'état

app.mount('#app')

if (process.env.NODE_ENV !== 'production') { // Alternative plus générique
    window.myApp = app; // Expose l'instance de l'application Vue globalement
    window.myRouter = router; // Expose l'instance du routeur globalement
    window.myStore = pinia;   // Expose l'instance du store globalement
}
